<table>
    <thead>
        <tr>
            <th class="subtable string">{{'reetiquetado.table.tabs.confeccion.confeccion' | translate}}</th>
            <th class="subtable string">{{'reetiquetado.table.tabs.confeccion.etiquetas' | translate}}</th>
            <th class="subtable number">{{'reetiquetado.table.tabs.confeccion.kilos' | translate}}</th>
        </tr>
    </thead>
    <tbody *ngFor="let confeccion of confeccionesPg">
        <tr>
            <td class="string">{{confeccion.desConfeccion}}</td>
            <td class="string">{{confeccion.sumaNumEtiquetasReimpresas | number : '1.0-0': defaultLanguage}}</td>
            <td class="number">{{confeccion.sumaKgReimpresos | number : '1.2-2': defaultLanguage}}</td>
        </tr>
    </tbody>
</table>
<app-paginator *ngIf="confecciones && confecciones.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
</app-paginator>